import React from 'react';
import { alignSingleBarLeft, hideBarPadLabel, CHART_PALETTE, CHART_TITLE_STYLE } from "../HelperFunction/helperFunction";
import ExceptionVariables from '../JSON Files/ExceptionVariables';
import Chart from 'react-apexcharts';
import { useOutletContext } from 'react-router-dom';

function SingleBarChart5({ fulldataset, type, isValue, range, maxValuedynamicVolume, maxValuedynamicValue, axisMax }) {
  const { theme } = useOutletContext();
  const isDark = theme !== 'light';
  let maxValue = isValue ? maxValuedynamicValue : maxValuedynamicVolume;
  let hidevar = ExceptionVariables.hiddenroichart;
  let filtered_data = fulldataset?.plot10.filter((it)=> it.contribution > 0 )
  const filtered = filtered_data?.filter(varObj => !hidevar?.includes(varObj?.variable));
  
  // Determine if the data contains 'frequency'
  const isStacked = filtered?.some(item => item.frequency);
  if(isStacked){
    maxValue=3*maxValue
      }
  if (Number(axisMax) > 0) maxValue = Number(axisMax);
  let categories, series;

  if (isStacked) {
    // Extract unique frequencies and variables
    let uniqueFrequencies = Array.from(new Set(filtered.map(item => item?.frequency)));
    let uniqueVariables = Array.from(new Set(filtered.map(item => item?.variable)));

    // Group data by variable (stacked chart case)
    series = uniqueVariables.map(variable => {
      return {
        name: variable,
        data: uniqueFrequencies.map(frequency => {
          let dataPoint = filtered.find(item => item.variable === variable && item.frequency === frequency);
          return dataPoint ? (isValue ? Number(dataPoint.contribution_sales_value / 100000).toFixed(2) : Number(dataPoint.contribution).toFixed(0)) : 0;
        })
      };
    });
    categories = uniqueFrequencies;
  } else {
    // Extract unique variables (non-stacked case)
    let uniqueVariables = Array.from(new Set(filtered.map(item => item?.variable)));
    
    // Group data normally
    series = [{
      name: "Contribution",
      data: uniqueVariables.map(variable => {
        let dataPoint = filtered.find(item => item.variable === variable);
        return dataPoint ? (isValue ? Number(dataPoint.contribution_sales_value / 100000).toFixed(2) : Number(dataPoint.contribution).toFixed(0)) : 0;
      })
    }];
    categories = uniqueVariables;
  }

  ({ categories, series } = alignSingleBarLeft(categories, series));
  const barColumnWidth = `${Math.min(70, Math.max(categories?.length || 1, 1) * 11)}%`;

  const options = {
    chart: {
      id: `Download-Contribution Chart for Incremental Variables`,
      type: 'bar',
      stacked: isStacked,
      toolbar: {
        show: true,
      },
      background: 'transparent',
    },
    grid: {
      show: false,
    },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
    },
    title: {
      text: `Contribution ${isValue ? "Value" : "Volume"} for Incremental Variables (${type})`,
      align: 'center',
      style: CHART_TITLE_STYLE,
    },
    colors: CHART_PALETTE,
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: barColumnWidth,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: isStacked?false:true,
      offsetY: -15,
      style: {
        fontFamily: "'JetBrains Mono', 'Inter', monospace",
        fontSize: '12px',
        fontWeight: 600,      },
      formatter: function (val) {
        return (val?.toLocaleString("en-IN"));
      },
    },
    xaxis: {
      categories: categories,
      title: {
        text: isStacked ? 'Frequency' : 'Variables',
        style: {
          fontWeight: 600,
          fontSize: "12px",        },
      },
      labels: {
        rotate: -40,
        rotateAlways: true,
        formatter: (val) => hideBarPadLabel(val),
        style: {
          fontWeight: 500,
          fontSize: "10px",        },
        offsetY: -6,
      },
    },
    yaxis: {
      axisBorder: {
        show: true
      },
      min: 0,
      max: Math.ceil(maxValue),
      labels: {
        style: {
          fontWeight: 500,
          fontSize: "11px",        },
        formatter: function (val) {
          return val?.toFixed(0);
        },
      },
    },
    legend: {
      show: isStacked,
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: "12px",    },
    annotations: {
      yaxis: [{
        y: 0,
        borderColor: '#6C757D',
        label: {
          text: '',
          style: {
            color: '#6C757D',
            background: '#1A252F'
          }
        }
      }]
    },
  };

  return (
    <>
      <div className="rr-chart-period">
        <small>Time Period: {range}</small>
      </div>
      <div className="rr-chart-yaxis">
        <span className="rr-chart-yaxis-label">
          {`Contribution ${isValue ? "Value (Lacs)" : "Volume (Kgs)"}`}
        </span>
        <div className="rr-chart-yaxis-body">
          <Chart className="rr-apex rr-apex-bar"
            align="center"
            options={options}
            series={series}
            type="bar"
            height={320}
            width={'100%'}
          />
        </div>
      </div>
    </>
  );
}

export default SingleBarChart5;
